import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
}
const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-rose-700 hover:bg-rose-800 rounded-full shadow-lg shadow-rose-900/20 transition-[background-color,transform,box-shadow] duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-800 focus-visible:ring-offset-2 focus-visible:ring-offset-stone-50';
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  ...props
}: ButtonProps) {
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.15,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-54" data-mp="30q72l8czjh2d">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.15,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-55" data-mp="8aqmep4pm1h4">
      {children}
    </motion.button>;
}